import {
  Alert,
  AlertTitle,
  Table,
  TableCell,
  TableRow
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import moment from 'moment';

function SecondDynamicForm({ rfqDetails, type = null, policyDetail = null }) {
  const [dynamicFormStrucure, setDynamicFormStrucure] = useState([]);

  useEffect(() => {
    let dynamicFormData = [];
    if (rfqDetails?.secondDynamicFormData?.length > 0) {
      dynamicFormData = rfqDetails.secondDynamicFormData;
    } else if (rfqDetails?.rfqTemplate?.secondDynamicFormStructure) {
      dynamicFormData = rfqDetails.rfqTemplate.secondDynamicFormStructure;
    }
    setDynamicFormStrucure(dynamicFormData || []);
  }, [rfqDetails]);

  /* ---------------- VALUE RESOLVER ---------------- */

  const extractValue = (val) => {
    if (val === null || val === undefined || val === '') return null;

    if (typeof val === 'string' || typeof val === 'number') return val;

    if (Array.isArray(val)) {
      return val
        .map(v => extractValue(v))
        .filter(Boolean)
        .join(', ');
    }

    if (typeof val === 'object') {
      if ('value' in val) return extractValue(val.value);
      if ('label' in val) return extractValue(val.label);
      return Object.values(val)
        .map(v => extractValue(v))
        .filter(Boolean)
        .join(', ');
    }

    return null;
  };

  const renderValue = (field) => {
    const resolved = extractValue(field?.value);

    if (!resolved) return 'N/A';

    if (field.type === 'DatePicker') {
      return moment(resolved).isValid()
        ? moment(resolved).format('DD-MM-YYYY')
        : 'N/A';
    }

    return resolved;
  };

  /* ---------------- STYLES ---------------- */

  const getTextStyle = (field) => ({
    fontStyle: field?.style?.italic ? 'italic' : 'normal',
    fontWeight: field?.style?.bold ? 'bold' : 'normal',
    textDecoration: field?.style?.underline ? 'underline' : 'none'
  });

  const getLabelStyle = (field) => ({
    ...(type === 'qc'
      ? {
        width: '50%',
        maxWidth: '50%',
        padding: '4px 16px',
        overflowWrap: 'break-word'
      }
      : {
        width: '36.3vw',
        paddingLeft: '0px'
      }),
    ...getTextStyle(field)
  });

  const getValueStyle = (field) => ({
    ...(type === 'qc'
      ? {
        width: '50%',
        maxWidth: '50%',
        padding: '4px 16px',
        overflowWrap: 'break-word'
      }
      : {
        paddingLeft: '2px'
      }),
    ...getTextStyle(field)
  });

  /* ---------------- RENDER ---------------- */

  return (
    <Table sx={{ pointerEvents: 'none', width: '100%' }}>
      {dynamicFormStrucure.map((form, idx) => (
        <React.Fragment key={idx}>
          {form?.groupName && (
            <TableRow>
              <TableCell
                colSpan={2}
                sx={{
                  background: 'rgb(9 84 174)',
                  color: '#fff',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  padding: '4px'
                }}
              >
                {form.groupName}
              </TableCell>
            </TableRow>
          )}

          {!form.masterForms?.length ? (
            <TableRow>
              <TableCell colSpan={2}>
                <Alert severity="warning">
                  <AlertTitle>No Input Fields</AlertTitle>
                </Alert>
              </TableCell>
            </TableRow>
          ) : (
            form.masterForms.map((field, i) => (
              <TableRow key={i}
                style={{
                  opacity:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.dynamic_form_2_detail?.status === 'approve'
                      ? 0.5
                      : 1,
                  pointerEvents:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.dynamic_form_2_detail?.status === 'approve'
                      ? 'none'
                      : 'auto',

                }}
              >
                <TableCell sx={getLabelStyle(field)} className="tbCol">
                  {field.hideLabel ? '' : field.label}
                </TableCell>
                <TableCell sx={getValueStyle(field)} className="tbCol">
                  {renderValue(field)}
                </TableCell>
              </TableRow>
            ))
          )}
        </React.Fragment>
      ))}
    </Table>
  );
}

export default SecondDynamicForm;
